import React, { useState, useEffect } from "react";
import { Button, Card, Typography } from "antd";
import "./InstallButton.css";

const { Title, Paragraph } = Typography;

const InstallButton: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsVisible(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") {
        console.log("User accepted the install prompt");
      } else {
        console.log("User dismissed the install prompt");
      }
      setDeferredPrompt(null);
      setIsVisible(false);
    }
  };

  if (!isVisible) {
    return (
      <div className="pwa-install-container">
        <Card className="install-card">
          <Title level={3}>App Installation</Title>
          <Paragraph>
            This app can be installed on your device. Please visit this page on
            a supported browser to see the install option.
          </Paragraph>
        </Card>
      </div>
    );
  }

  return (
    <div className="pwa-install-container">
      <Card className="install-card">
        <Title level={3}>Install App</Title>
        <Paragraph>
          Click the button below to install this app on your device for a better
          experience.
        </Paragraph>
        <Button
          type="primary"
          size="large"
          onClick={handleInstallClick}
          className="install-button"
        >
          Install App
        </Button>
      </Card>
    </div>
  );
};

export default InstallButton;
